import ReactDOM from "react-dom/client";
import { Toaster } from "./components/ui/common/sonner";

import App from "./App";
import { ThemeContextProvider } from "./context/ThemeContext";

import { AuthProvider } from "react-oidc-context";
import "react-resizable/css/styles.css";
import { CompanyProvider } from "./context/CompanyContext";
import "./index.css"; // Tailwind first
import "./index.scss";

const cognitoAuthConfig = {
  authority: process.env.REACT_APP_AUTHORITY,
  client_id: process.env.REACT_APP_COGNITO_CLIENT_ID,
  redirect_uri: process.env.REACT_APP_COGNITO_REDIRECT_URI,
  post_logout_redirect_uri: process.env.REACT_APP_COGNITO_LOG_OUT_URI,
  end_session_endpoint: `${process.env.REACT_APP_COGNITO_DOMAIN}/logout`,
  response_type: "code",
  scope: "phone openid email"
};

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
  <AuthProvider {...cognitoAuthConfig}>
    <ThemeContextProvider>
      <CompanyProvider>
        <Toaster />
        <App />
      </CompanyProvider>
    </ThemeContextProvider>
  </AuthProvider>
);
